module.exports = new __parcel__URL__("Smoke15Frames_Black.bd896f7e.png").toString();